'use client';

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './Richtext.module.scss';
import classNames from 'classnames';

const Richtext = ({ text = '', modifier = '', isSmallText }) => {
    const [processedText, setProcessedText] = useState(text);

    const classes = classNames(s.Root, [s[`Root--${modifier}`]], {
        [s['Root--Small']]: isSmallText,
    });

    useEffect(() => {
        const addTargetBlank = (html) => {
            const div = document.createElement('div');
            div.innerHTML = html;

            const links = div.querySelectorAll('a');
            links.forEach((link) => {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
            });

            return div.innerHTML;
        };

        setProcessedText(addTargetBlank(text));
    }, [text]);

    return (
        <div
            className={classes}
            dangerouslySetInnerHTML={{ __html: processedText }}
        />
    );
};

Richtext.propTypes = {
    text: PropTypes.string,
    modifier: PropTypes.string,
};

export default Richtext;
